module.exports = __webpack_public_path__ + "img/auth0.95793651.svg";